module.exports = __webpack_public_path__ + "img/新华网_01.0b2b72d8.jpg";